import { Button } from '@mui/material';
import classNames from 'classnames';
import React from 'react';

import styles from './index.module.scss';

const CancelAction = ({
  onClick,
  btnText,
  disabled,
  role,
}: {
  onClick?(): void;
  btnText?: string;
  disabled?: boolean;
  role?: string;
}) => (
  <Button
    className={classNames('font-semibold p-0', styles.btn, styles.cancelBtn)}
    variant="text"
    role={role}
    disabled={disabled ?? false}
    onClick={onClick}
  >
    {btnText ?? 'Cancel'}
  </Button>
);

export default CancelAction;
